import "./class-component-hooks"; // needs to be imported before any components
import Vue from "vue";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import moment from "moment";
require("@/assets/style.css");

Vue.filter("formatDate", (value: any) => {
	if (value) {
		return moment(String(value)).format("DD.MM.YYYY");
	}
});

Vue.filter("formatTimespan", (value: any) => {
	if (value) {
		return moment(String(value)).format("hh:mm:ss");
	}
});
Vue.filter("formatDateAndTime", (value: any) => {
	if (value) {
		return moment(String(value)).format("DD.MM.YYYY HH:mm:ss");
	}
});
Vue.filter("format2Digit", (value: number) => {
	if (isNaN(value)) {
		return "";
	}
	return value.toFixed(2);
});
Vue.filter("format2DigitWithSeparators", (value: number) => {
	return value
		.toFixed(2)
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
});
Vue.filter("format3Digit", (value: number) => {
	return value.toFixed(3);
});

Vue.config.productionTip = false;
console.log("running: " + process.env.VUE_APP_MODE);
store
	.dispatch("bootstrap")
	.then(async () => {
		console.log("Successfully bootstrapt application");
		store
			.dispatch("checkAccess")
			.then(async () => {
				store.dispatch("setupSignalR").then(async () => {
					store.dispatch("loadManufacturers").then(async () => {
						const app = new Vue({
							el: "#app",
							store,
							router,
							render: (h) => h(App),
						});
					});
				});
			})
			.catch((e) => {
				console.log("Keine Berechtigung");
				//store.dispatch('logout');
			});
	})
	.catch((e) => console.log(e));
